import { Outlet, useNavigate } from "react-router-dom";
import InspectorSidebar from "./InspectorSidebar";
import { Container, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import "./Clean.css";
import logo from "../assets/images/logos/logo.png";
import { FaUserCircle } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";

const InspectorLayout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const toggleSidebar = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  // Logout function
  const handleLogout = () => {
    logout();
    navigate('/Login');
  };

  return (
    <main>
      {/* Full width top border */}
      <div style={{ 
        width: '100%',
        height: '4px',
        backgroundColor: '#d4d700'
      }}></div>
      {/* Full width top row with hamburger icon */}
      <div className="w-100" style={{ 
        background: 'linear-gradient(90deg, rgb(77 140 159), rgb(56 143 172))',
        zIndex: 1000,
        position: 'relative',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
      }}>
        <div className="d-flex align-items-center justify-content-between" style={{ padding: '1rem' }}>
          <div className="d-flex align-items-center">
            <Button
              color="link"
              size="sm"
              className="text-white me-3"
              onClick={toggleSidebar}
              style={{ border: 'none', padding: '0.5rem' }}
            >
              <i className="bi bi-list" style={{ fontSize: '1.5rem' }}></i>
            </Button>
            <img 
              src={logo} 
              alt="Studorez Logo" 
              style={{ height: '40px', cursor: 'pointer' }} 
              onClick={() => navigate('/inspector-dashboard')}
            />
          </div>
          <div className="d-flex align-items-center">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle
                color="link"
                className="text-white d-flex align-items-center"
                style={{ textDecoration: 'none' }}
              >
                <FaUserCircle size={28} />
                <span className="ms-2">Inspector</span>
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem onClick={() => navigate('/inspector-dashboard/profile')}>
                  <i className="bi bi-person me-2"></i>Profile
                </DropdownItem>
                <DropdownItem onClick={() => navigate('/inspector-dashboard/settings')}>
                  <i className="bi bi-gear me-2"></i>Settings
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-2"></i>Logout
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
      </div>

      <div className="pageWrapper d-lg-flex">
        {/***********Sidebar**************/}
        <aside className="sidebarArea shadow" id="sidebarArea">
          <InspectorSidebar />
        </aside>
        {/***********Content Area**************/}
        <div className="contentArea">
          <Container className="p-4" fluid>
            <Outlet />
          </Container>
        </div>
      </div>
    </main>
  );
};

export default InspectorLayout;
